/**
 * Confirm modal for completing an RMA ("mark as done"): dashboard copy and ET-2533 confirmed Mixpanel on submit.
 */
import { observer } from "mobx-react";
import { IRmaMarkAsDoneAction } from "../../stores/rma-page-store";
import { ConfirmModal } from "../../../../../components/modal/components/confirm-modal/confirm-modal";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";

interface IProps {
	rmaAction: IRmaMarkAsDoneAction;
	onCloseClick: () => void;
}

const RmaActionMarkAsDoneModal: React.FC<IProps> = observer(({rmaAction, onCloseClick}) => {
	const actionStore = rmaAction.store;

	const {getTranslation} = useDashboardTranslation();
	const scope = "dashboard-returns-rma-card";

	const handleSubmit = () => {
		actionStore.submitAction(() => {
			rmsMixpanelStore.trackEvent("d&_mark_as_done_button_confirmed");
			onCloseClick();
		});
	};

	const handleDismiss = () => {
		rmsMixpanelStore.trackEvent("d&_rma_keep_current_status");
		onCloseClick();
	};

	return (
		<ConfirmModal
			title={
				rmaAction.modalTitleTranslationKey
					? getTranslation(rmaAction.modalTitleTranslationKey, scope)
					: getTranslation(rmaAction.name, scope)
			}
			text={getTranslation(rmaAction.descriptionTranslationKey, scope)}
			cancelButton={{
				title: getTranslation("KEEP_CURRENT_STATUS", scope),
				onClick: handleDismiss,
			}}
			okButton={{
				title: getTranslation(rmaAction.buttonTextTranslationKey, scope),
				onClick: handleSubmit,
				hasLoader: true,
				isLoading: actionStore.isProcessing,
			}}
		/>
	);
});

export default RmaActionMarkAsDoneModal;
